/** Phone number management GraphQL operations. Result types are inferred from the selection sets. */

import { graphql } from 'app/generated/gql'

// ─── Public schema ───────────────────────────────────────────────────────────

export const PHONE_NUMBERS_QUERY = graphql(`
  query LocationPhoneNumbers($search: String, $pagination: PaginationInput, $sort: SortInput) {
    phoneNumbers(search: $search, pagination: $pagination, sort: $sort) {
      hits {
        id
        orgId
        workspaceId
        locationId
        phone
        provider
        providerResourceId
        roles
        label
        registrationStatus
        registrationId
        enabled
        provisioningStatus
        provisioningError
        createdDate
        updatedDate
      }
      total
      page
    }
  }
`)

// ─── Ops schema ──────────────────────────────────────────────────────────────

export const SEARCH_AVAILABLE_QUERY = graphql(`
  query SearchAvailablePhoneNumbers($type: PhoneNumberType!, $areaCode: String!, $limit: Int) {
    searchAvailablePhoneNumbers(type: $type, areaCode: $areaCode, limit: $limit) {
      phone
      type
      locality
    }
  }
`)

export const PURCHASE_MUTATION = graphql(`
  mutation PurchasePhoneNumber($input: PurchasePhoneNumberInput!) {
    purchasePhoneNumber(input: $input) {
      id
      phone
      provider
      roles
      label
      provisioningStatus
      provisioningError
      registrationStatus
      enabled
      createdDate
    }
  }
`)

export const UPDATE_ROLES_MUTATION = graphql(`
  mutation UpdatePhoneNumberRoles($id: ID!, $input: UpdatePhoneNumberInput!) {
    updatePhoneNumber(id: $id, input: $input) {
      id
      roles
      label
      enabled
      updatedDate
    }
  }
`)

export const RELEASE_MUTATION = graphql(`
  mutation ReleasePhoneNumber($id: ID!) {
    releasePhoneNumber(id: $id) {
      id
      provisioningStatus
      enabled
    }
  }
`)
